import React from "react";
import * as HeroIcons from "@heroicons/react/outline";
import { TitleHeading } from "../typography/TitleHeading";
import Keyword from "../typography/Keyword";
import SideImage from "../layout/SideImage";
import { useAnimation } from "../../hooks/useAnimate";

interface ImageFeaturesGridProps {
  tag: string;
  title: string;
  theme?: "white" | "gray";
  elements: {
    icon: string;
    name: string;
    description: string;
  }[];
  image: string;
}

export const ImageFeaturesGrid: React.FunctionComponent<
  ImageFeaturesGridProps
> = ({ tag, title, elements, theme, image }) => {
  const { id, animate } = useAnimation();

  return (
    <SideImage theme={theme} position="right" image={image} id={id}>
      <div {...animate("fade-down")}>
        <TitleHeading mobileCenter tag={tag} title={title} theme={theme} />
      </div>
      <div className="mt-16 grid md:grid-cols-2 xl:grid-cols-3 gap-6 lg:gap-10">
        {elements.map((el, i) => {
          const Icon = HeroIcons[el.icon];
          return (
            <div key={el.name} {...animate("fade-right", i * 50)}>
              <div className="flex items-center justify-center h-12 w-12 rounded-xl bg-gray-900 dark:bg-gray-800 mb-4 mx-auto md:mx-0">
                <Icon className="h-6 w-6 text-white" />
              </div>
              <Keyword
                mobileCenter={true}
                title={el.name}
                description={el.description}
              />
            </div>
          );
        })}
      </div>
    </SideImage>
  );
};
